import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@common-ui-library/atom';
import { useI18n, useBIEvents } from '@common-ui-library/shared';
import { EleosLogo } from '@common-ui-library/molecule';
import { BI_GENERIC_ERROR_PAGE_VIEW } from '../Utils/biEvents';

interface GenericErrorPageProps {
  eventId?: string;
}

export const GenericErrorPage: React.FC<GenericErrorPageProps> = ({ eventId }) => {
  const { t } = useI18n();
  const { sendBIEvent } = useBIEvents();

  // Emit BI event on mount
  useEffect(() => {
    sendBIEvent(BI_GENERIC_ERROR_PAGE_VIEW);
  }, [sendBIEvent]);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: 'background.default',
        p: 3,
        textAlign: 'center',
      }}
    >
      <Box sx={{ mb: 4 }}>
        <EleosLogo />
      </Box>
      <Typography variant="h4" gutterBottom>
        {t('errors.somethingWentWrong')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2, maxWidth: 500 }}>
        {t('errors.unexpectedError')}
      </Typography>
      {eventId && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 4 }}>
          Error ID: {eventId}
        </Typography>
      )}
      <Button variant="contained" color="primary" onClick={handleRefresh} sx={{ mt: 2 }}>
        {t('actions.refreshPage')}
      </Button>
    </Box>
  );
};

